export interface DocumentIds {
  spreadsheetId: string;
  worksheetId?: string | number;
}

export function extractDocumentIds(url: string): DocumentIds {
  const urlParser = new URL(url);

  if (urlParser.origin !== 'https://docs.google.com') {
    throw new Error('Validation failure: invalid Google Sheets URL');
  }

  const spreadsheetIdPattern = /^\/spreadsheets(?:\/d)?\/(?<spreadsheetId>[a-zA-Z0-9-_]{2,})/i;
  const spreadsheetId = spreadsheetIdPattern.exec(urlParser.pathname)?.['groups']?.['spreadsheetId'];

  if (spreadsheetId == null) {
    throw new Error('Validation failure: cannot extract spreadsheet ID from invalid URL');
  }

  const result: DocumentIds = { spreadsheetId };
  const worksheetIdPattern = /#gid=(?<worksheetId>\d+)/;
  const worksheetId = worksheetIdPattern.exec(urlParser.hash)?.['groups']?.['worksheetId'];

  if (worksheetId) {
    result.worksheetId = worksheetId;
  }

  return result;
}
